import { PlanesComerciales } from './../../../core/constants/planes';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  faCheckCircle,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { UtilsService } from 'src/app/core/services/utils.service';
import { PaymentService } from 'src/app/core/services/payment.service';
import { LoginComponent } from '../login/login.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.scss'],
})
export class PlansComponent implements OnInit {
  public faCheckCircle = faCheckCircle;
  public faTimesCircle = faTimesCircle;
  public usuario = null;
  public planes = PlanesComerciales.planes;
  public tipo = 'marketplace'; //TIPO**
  public caracts = null;

  constructor(
    private router: Router,
    private svUtils: UtilsService,
    private svPayment: PaymentService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    localStorage.setItem('loginFromDemo', 'false');
    this.getLoggedUser();
  }

  getLoggedUser() {
    this.usuario = this.svUtils.getLoggedUser();
  }
  getCaracteristicas(array) {
    return array;
  }

  changePlan(tipo) {
    switch (tipo) {
      case 'marketplace': {
        this.planes = PlanesComerciales.planes;
        this.tipo = 'marketplace';
        break;
      }
      case 'feria': {
        this.planes = PlanesComerciales.planesFeria;
        this.tipo = 'feria';
        break;
      }
      case 'feriaescolar': {
        this.planes = PlanesComerciales.planesFeriaEscolar;
        this.tipo = 'feriaescolar';
        break;
      }
      default: {
        //statements;
        break;
      }
    }
  }

  parseAmount(value: number): string {
    if (value) {
      return this.svUtils.parseNumberToPesos(value);
    } else {
      return '$ 0';
    }
  }

  goToPayment(nombre_plan, precio, dias_disponible, cantidad_de_asistentes) {
    localStorage.setItem('plan_comercial', dias_disponible);
    localStorage.setItem('cantidad_de_asistentes', cantidad_de_asistentes);

    let returnUrl = `${window.location.href.replace('/auth/plans', '')}`;
    if (this.usuario) {
      if (localStorage.getItem('loginFromDemo') == 'true') {
        this.router.navigate([`auth/start-demo`]);
        return;
      }
      this.svPayment.goToPay(precio, `${returnUrl}/auth/confirmation-payment`);
      // if (nombre_plan == 'Max') {
      //   window.location.replace(
      //     'https://www.flexipay.com.co/p/gateway?fti=89b1d7a0e170d72d13df097993cc622db17ad370dc32145ddf2aadbca806c6e27737e236'
      //   );
      // } else if (nombre_plan == 'Ligth') {
      //   window.location.replace(
      //     'https://www.flexipay.com.co/p/gateway?fti=ddd15f7d19183c8f2fad1a2336c2d4d81900cc859c7554a4dbb9418fc50ca6d45e4218a5'
      //   );
      // }
      return;
    }
    this.router.navigate([
      `/pre-payment/${btoa(precio)}/${btoa(returnUrl.replace('/plans', ''))}`,
    ]);
  }

  getDemo(cantidad_de_asistentes): any {
    localStorage.setItem('loginFromDemo', 'true');
    localStorage.setItem('cantidad_de_asistentes', cantidad_de_asistentes);
    if (this.usuario) {
      this.router.navigate(['auth/start-demo']);
      return;
    }

    const dialogRef = this.dialog.open(LoginComponent, {
      width: '380px',
      height: '550px',
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: { action: 'login' },
    });
  }

  contact() {
    if (this.usuario) {
      this.router.navigate(['auth/contact']);
      return;
    }
    this.router.navigate(['contact']);
  }
}
